/**
 * This will prevent invalid props from being passed to DOM elements (and an
 * ugly React warning). Ideally,
 * this should be prevented from within the component. However, when utilizing
 * third party libraries that spread any user-provided props to a DOM element
 * (i.e., <input {...rest} />), this becomes necessary.
 * see: https://github.com/styled-components/styled-components/issues/1198
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
var removeProps = function (propsToFilter) {
    return function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        var shouldFilter = propsToFilter.includes(key);
        if (shouldFilter) {
            return acc;
        }
        return __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b));
    };
};
var filterProps = function (Component, propsToFilter) {
    var WrappedComponent = function (props) {
        var className = props.className, rest = __rest(props, ["className"]);
        var filteredProps = Object.entries(rest).reduce(removeProps(propsToFilter), {});
        return React.createElement(Component, __assign({ className: className }, filteredProps));
    };
    return WrappedComponent;
};
export default filterProps;
//# sourceMappingURL=filterProps.js.map